import {
  Box,
  Skeleton,
  Button,
  Typography,
  Checkbox,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../api/api';
import PersonRadio from '../radio/PersonRadio';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
const AddMembers = ({
  members,
  onSubmit,
  filter,
  api,
  onClose = () => {},
  className = 'p-2',
  component,
  project,
  showPermissions,
  supervisorId,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  // request
  const [employees, setEmployees] = useState(null);
  const config = useConfig();
  useEffect(() => {
    if (!config) return;
    DBRequest({
      config,
      path: api || 'users?' + filter,
      method: API_GET,
      onResponse: setEmployees,
    });
  }, [config]);

  // process start data
  const [selectedIds, setSelectedIds] = useState([]);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const arrayOfIds = members.map((obj) => obj.id);
    setSelectedIds(arrayOfIds);
    if (showPermissions) {
      const perms = {};
      members.forEach((m) => {
        perms[m.id] = m.canWrite || false;
      });
      setPermissions(perms);
    }
  }, [members]);

  // aktions
  function handleChange(employee) {
    if (selectedIds.includes(employee.id)) {
      setSelectedIds(selectedIds.filter((item) => item !== employee.id));
    } else {
      setSelectedIds([...selectedIds, employee.id]);
    }
  }

  function toggleCanWrite(userId) {
    setPermissions((prev) => ({
      ...prev,
      [userId]: !prev[userId],
    }));
  }

  // submit
  function handleSubmit() {
    const newMember = employees.data.filter((obj) =>
      selectedIds.includes(obj.id)
    );
    if (showPermissions) {
      const membersWithPermissions = newMember.map((m) => ({
        ...m,
        canWrite:
          m.id === supervisorId ? true : permissions[m.id] || false,
      }));
      onSubmit(selectedIds, newMember, membersWithPermissions);
    } else {
      onSubmit(selectedIds, newMember);
    }
  }

  const PermissionSwitch = ({ person, selected }) => {
    if (!showPermissions || !selected) return null;
    const isSupervisor = person.id === supervisorId;

    if (isSupervisor) {
      return (
        <Typography
          variant="body2"
          sx={{
            opacity: 0.7,
            fontSize: '0.75rem',
            whiteSpace: 'nowrap',
            fontStyle: 'italic',
          }}
        >
          {t('Supervisor')}
        </Typography>
      );
    }

    return (
      <Box
        className="flex items-center gap-2"
        onClick={(e) => e.stopPropagation()}
      >
        <Typography
          variant="body2"
          sx={{ opacity: 0.7, fontSize: '0.75rem', whiteSpace: 'nowrap' }}
        >
          {t('Write Permissions')}
        </Typography>
        <Checkbox
          checked={permissions[person.id] || false}
          onChange={() => toggleCanWrite(person.id)}
          size="small"
          sx={{
            color: colors.info,
            '&.Mui-checked': {
              color: colors.info,
            },
          }}
        />
      </Box>
    );
  };

  return (
    <Box
      className={`${className} flex flex-col h-full`}
      sx={{ height: 'calc(90vh - 75px)', width: '650px', maxWidth: '100%' }}
    >
      <Typography variant="h2" textAlign="center" className="py-2">
        {t('Team Members')}
      </Typography>

      <Box className="flex flex-col gap-2 overflow-y-auto pr-2 flex-1">
        {!employees ? (
          <>
            {[...Array(8)].map((element, index) => (
              <Skeleton key={'skeleton-select-employee-' + index} height={204} />
            ))}
          </>
        ) : (
          <>
            {employees.data.map((element, index) => (
              <Box
                key={'select-employee-' + element.id}
                sx={
                  showPermissions && element.id === supervisorId
                    ? {
                        border: `1.5px solid ${colors.info}`,
                        borderRadius: '10px',
                      }
                    : {}
                }
              >
                <PersonRadio
                  person={element}
                  onClick={(e) => handleChange(e, element)}
                  checked={selectedIds.includes(element.id)}
                  component={showPermissions ? PermissionSwitch : component}
                  project={project}
                />
              </Box>
            ))}
          </>
        )}
      </Box>
      <Box className="pt-2 flex flex-row justify-between">
        <Button onClick={onClose} color="error" variant="outlined">
          {t('Cancel')}
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="success">
          {t('Save')}
        </Button>
      </Box>
    </Box>
  );
};

export default AddMembers;
